export default "__VITE_ASSET__CLMWC4Oh__"